import { PageReadyTiming } from "./types";
import { TrackingContext } from "./TrackingContext";
import { PerfTrackingModule } from "./perf-tracker/PerfTrackingModule";
import { StabilityTrackingModule } from "./StabilityTrackingModule";
import { bindTimestampHandler } from "./time";
const instances = {};
const createInstance = (instanceName = "") => {
  let _hasInit = false;
  class TrackingModule {
    resetForSPA() {
      this._stabilityTracker.resetForSPA();
      this._perfTracker.resetForSPA();
    }
    reset() {
      this.resetForSPA();
      _hasInit = false;
      this._trackingContext.resetSlardarModule();
      this._trackingContext.resetTeaModule();
    }
    isInitialized() {
      return _hasInit;
    }
    constructor(instanceName2 = "") {
      this._pageReadyTiming = PageReadyTiming.ACTUAL_FMP;
      this.init = (arg) => {
        try {
          if (_hasInit) {
            return;
          }
          _hasInit = true;
          const { slardarContainer, slardarWindowGlobalName, slardarHybridGlobalName, sparkMonitor, reportActualFMP, pageReadyTiming = PageReadyTiming.CUSTOM, jsbBridge, shouldReportJSError = {}, shouldRegisterUserDrop = true } = arg !== null && arg !== void 0 ? arg : {};
          this._pageReadyTiming = pageReadyTiming;
          this._trackingContext.initSlardar({
            slardarContainer,
            slardarWindowGlobalName,
            slardarHybridGlobalName,
            sparkMonitor,
            reportActualFMP,
            shouldReportJSError
          });
          if (jsbBridge) {
            this._trackingContext.initJSB(jsbBridge);
          }
          bindTimestampHandler();
          if (shouldRegisterUserDrop) {
            this._registerUserDropEvent();
          }
        } catch (e) {
        }
      };
      this._registerUserDropEvent = () => {
        window.addEventListener("beforeunload", this.reportUserDrop, true);
      };
      this.reportPageReady = (scene) => {
        this._stabilityTracker.reportPageReady();
        if (this._pageReadyTiming === PageReadyTiming.ACTUAL_FMP) {
          this._perfTracker.reportActualFMP(scene);
        }
      };
      this.reportUserDrop = () => {
        this._stabilityTracker.reportUserDrop();
      };
      this.reportPageCrash = (error, hasDifferentTriggerTime = false, componentStack) => {
        this._stabilityTracker.reportPageCrash(error, hasDifferentTriggerTime, componentStack);
      };
      this.reportFBJS = () => {
        this._perfTracker.reportFBJS();
      };
      this.reportActualFMP = (scene) => {
        this._perfTracker.reportActualFMP(scene);
      };
      this.reportCUJ = (name, status, extra) => {
        this._stabilityTracker.reportCUJ(name, status, extra);
      };
      let _instance;
      if (!instanceName2) {
        if (!TrackingModule._instance) {
          TrackingModule._instance = this;
        }
        _instance = TrackingModule._instance;
      } else {
        instances[instanceName2] = this;
        _instance = this;
      }
      this._trackingContext = new TrackingContext();
      this._perfTracker = new PerfTrackingModule(this._trackingContext);
      this._stabilityTracker = new StabilityTrackingModule(this._trackingContext);
      return _instance;
    }
  }
  if (!instanceName) {
    return new TrackingModule();
  }
  if (!instances[instanceName]) {
    instances[instanceName] = new TrackingModule(instanceName);
  }
  return instances[instanceName];
};
const TrackingModuleSingleton = createInstance();
export {
  TrackingModuleSingleton as TrackingModule,
  createInstance
};
